class Enums {
    static WhetherLimit = [
        { value: 'true', name: '是' },
        { value: 'false', name: '否' },
    ];
    static WhetherEffective = [
        { value: 'true', name: '是' },
        { value: 'false', name: '否' },
    ];
    static getEnum(obj: any, isAll: boolean) {
        var data = [];
        if (isAll) {
            data.push({ value: null, name: '全部' });
        }
        for (var value of obj) {
            data.push({ value: value.value, name: value.name });
        }
        return data;
    }
}
export default Enums;